export const fetchApi = async (
    method: 'POST' | 'GET',
    url: string,
    parameters?: {},
    headers?: {},
    jsonResponse: boolean = true
) => {
    let options = {
        method,
        headers: {
            ...headers,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }

    if (typeof parameters === 'object' && Object.keys(parameters).length > 0) {
        options['body'] = JSON.stringify(parameters)
    }

    const rawResponse = await fetch(url, options)

    return (await jsonResponse) ? rawResponse.json() : rawResponse
}

export type SitemapFormatType = 'json' | 'xml'

export type SitemapFormat = {
    code: string
    label: string
}

export const availableSitemapFormat: SitemapFormat[] = [
    {
        code: 'json',
        label: 'JSON Format',
    },
    {
        code: 'xml',
        label: 'XML Format',
    },
]
